export default {
    editingTag: false,
    creatingTag: false,
    tag: null,
    originalTag: null,
    submitting: false,
    postCreateAction: null,
    postEditAction: null,
    fieldErrors: {}
};



// WEBPACK FOOTER //
// ./public/pages/EditBreak/BreakTagModal/initialState.js